import * as React from 'react';
import Raven from 'raven-js';
import FixedWidthEnrollmentFilterWrapper from 'flow-doctor-lib/components/diagnosis/FixedWidthEnrollmentFilterWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import EnrollmentValidationDebugFilterEvaluation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentValidationDebugFilterEvaluation';
import ClassicReenrollmentTriggerSetsRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentTriggerSetsRenderer';
import ListEventTriggerRenderer from 'flow-doctor-lib/components/filters/ListEventTriggerRenderer';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getListEventTriggers } from 'flow-doctor-lib/utils/flowUtils';
import PersistedReEnrollmentListDebugFilterRenderer from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/triggerChecks/PersistedReEnrollmentListDebugFilterRenderer';
import ListMembershipEventTriggerEvalRenderer from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/triggerChecks/ListMembershipEventTriggerEvalRenderer';
import ClassicReenrollmentTriggerSetsEvalRenderer from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/triggerChecks/ClassicReenrollmentTriggerSetsEvalRenderer';
import UILink from 'UIComponents/link/UILink';
import WalmartEventEnrollmentFilters from 'flow-doctor-lib/components/filters/WalmartEventEnrollmentFilters';
import usageTracker from 'flow-doctor-lib/usageTracker';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled, { useTheme } from 'styled-components';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ENROLL_EXISTING_KB_ARTICLE = 'https://knowledge.hubspot.com/workflows/workflows-faq#why-aren-t-existing-records-that-meet-a-workflow-s-enrollment-triggers-being-enrolled-in-the-workflow-after-turning-it-on';
const MarginTopContainer = styled.div.withConfig({
  displayName: "EnrollmentValidTriggerResultExplanation__MarginTopContainer",
  componentId: "sc-5m0cgo-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return `
   margin-top:  ${theme.space['400']}}
`;
});
const EnrollmentValidTriggerResultExplanation = ({
  validationResult,
  flowRevision
}) => {
  const theme = useTheme();
  switch (validationResult.enrollmentCategory) {
    case 'BULK_ENROLLMENT_LIST':
    case 'ENROLLMENT_LIST_MEMBERSHIP':
      {
        const enrollmentListId = validationResult.enrollmentList && validationResult.enrollmentList.listId;
        const hasMostRecentlyJoinedEnrollmentListWithBulk = 'hasMostRecentlyJoinedEnrollmentListWithBulk' in validationResult && validationResult.hasMostRecentlyJoinedEnrollmentListWithBulk;
        const unsupportedEnrollmentListSource = 'unsupportedEnrollmentListSource' in validationResult && validationResult.unsupportedEnrollmentListSource;
        if (!validationResult.enrollmentAllowed && hasMostRecentlyJoinedEnrollmentListWithBulk) {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.joinedEnrollmentListWithBulk.enrollExisting"
            }), /*#__PURE__*/_jsx(View, {
              marginBlock: "400",
              as: "div",
              children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.joinedEnrollmentListWithBulk.inOrderToMeet_jsx",
                elements: {
                  Link: UILink
                },
                options: {
                  external: true,
                  href: ENROLL_EXISTING_KB_ARTICLE
                }
              })
            }), /*#__PURE__*/_jsx(UILink, {
              external: true,
              href: ENROLL_EXISTING_KB_ARTICLE,
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.joinedEnrollmentListWithBulk.learnMore"
              })
            })]
          });
        }
        if (!validationResult.enrollmentAllowed && unsupportedEnrollmentListSource) {
          const supportedI18nKey = `flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.alreadyInList.${unsupportedEnrollmentListSource}`;
          if (isValidI18nKey(supportedI18nKey)) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: supportedI18nKey
            });
          }
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.alreadyInList.default'
          });
        }
        return /*#__PURE__*/_jsx(EnrollmentValidationDebugFilterEvaluation, {
          listId: enrollmentListId,
          evaluationResult: validationResult.debugFilterBranch,
          flowRevision: flowRevision,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.passed' : validationResult.enrollmentList ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.doesNotMeetCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.description.failed.noEnrollmentList'
          })
        });
      }
    case 'CLASSIC_REENROLLMENT_TRIGGER':
      {
        if (validationResult.triggerMatchResults.length === 0) {
          const {
            reEnrollmentTriggerSets
          } = flowRevision.flow.classicEnrollmentSettings;
          if (reEnrollmentTriggerSets.length === 0) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.noResults"
            });
          }
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.withResults"
            }), /*#__PURE__*/_jsx(MarginTopContainer, {
              theme: theme,
              children: /*#__PURE__*/_jsx(FixedWidthEnrollmentFilterWrapper, {
                children: /*#__PURE__*/_jsx(ClassicReenrollmentTriggerSetsRenderer, {
                  portalId: flowRevision.portalId,
                  objectTypeId: flowRevision.flow.objectTypeId,
                  condensed: true,
                  reEnrollmentTriggerSets: reEnrollmentTriggerSets
                })
              })
            })]
          });
        }
        const matchingReEnrollmentTriggerResult = validationResult.triggerMatchResults.find(r => r.matchResult === 'VALID');
        if (matchingReEnrollmentTriggerResult) {
          const matchingReEnrollmentTriggerSet = matchingReEnrollmentTriggerResult.triggerSet;
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.passed"
            }), /*#__PURE__*/_jsx(MarginTopContainer, {
              theme: theme,
              children: /*#__PURE__*/_jsx(FixedWidthEnrollmentFilterWrapper, {
                children: /*#__PURE__*/_jsx(ClassicReenrollmentTriggerSetsRenderer, {
                  portalId: flowRevision.portalId,
                  objectTypeId: flowRevision.flow.objectTypeId,
                  condensed: true,
                  reEnrollmentTriggerSets: [matchingReEnrollmentTriggerSet]
                })
              })
            })]
          });
        }
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.withResults"
          }), /*#__PURE__*/_jsx(ClassicReenrollmentTriggerSetsEvalRenderer, {
            portalId: flowRevision.portalId,
            objectTypeId: flowRevision.flow.objectTypeId,
            triggerMatchResults: validationResult.triggerMatchResults
          })]
        });
      }
    case 'PERSISTED_REENROLLMENT_LIST_MEMBERSHIP':
      {
        if (validationResult.enrollmentAllowed) {
          const matchingListResult = validationResult.associatedListsMatchResults.find(r => r.isValidTrigger);

          // This means the user selected the direct internal persisted re-enrollment list timeline item
          if (!matchingListResult) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.PERSISTED_REENROLLMENT_LIST_MEMBERSHIP.description.passed.directList"
            });
          }
          return /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(EnrollmentValidationDebugFilterEvaluation, {
              listId: matchingListResult.listId,
              evaluationResult: matchingListResult.debugFilterBranch,
              flowRevision: flowRevision,
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.PERSISTED_REENROLLMENT_LIST_MEMBERSHIP.description.passed.trigger"
              })
            })
          });
        }
        if (validationResult.associatedListsMatchResults.length > 0) {
          const matchedSomePersistedList = validationResult.associatedListsMatchResults.some(r => r.debugFilterBranch.acceptedStatus === 'ACCEPTED');
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: matchedSomePersistedList ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.PERSISTED_REENROLLMENT_LIST_MEMBERSHIP.description.failed.match' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.PERSISTED_REENROLLMENT_LIST_MEMBERSHIP.description.failed.noMatch'
            }), /*#__PURE__*/_jsx(PersistedReEnrollmentListDebugFilterRenderer, {
              matchResults: validationResult.associatedListsMatchResults,
              flowRevision: flowRevision
            }), /*#__PURE__*/_jsx(MarginTopContainer, {
              theme: theme,
              children: /*#__PURE__*/_jsx(WalmartEventEnrollmentFilters, {
                portalId: flowRevision.portalId,
                flowObjectTypeId: flowRevision.flow.objectTypeId,
                flowEventFilters: flowRevision.flow.flowEventFilters,
                listEventTriggers: []
              })
            })]
          });
        }

        // If we get to this case, it's because the user chose a "REMOVED" event from a persisted re-enrollment list direct reference on the internal UI
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.PERSISTED_REENROLLMENT_LIST_MEMBERSHIP.description.failed.noMatchDirectList"
        });
      }
    case 'LIST_MEMBERSHIP_EVENT_TRIGGER':
      {
        const matchingAssociatedListResult = validationResult.associatedListsMatchResults.find(result => result.matchResult === 'VALID');
        if (matchingAssociatedListResult) {
          const matchingAssociatedList = flowRevision.flow.associatedLists.find(list => list.listId === matchingAssociatedListResult.listId);
          if (matchingAssociatedList) {
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.passed"
              }), /*#__PURE__*/_jsx(View, {
                marginBlockStart: "300",
                as: "div",
                children: /*#__PURE__*/_jsx(ListEventTriggerRenderer, {
                  associatedList: matchingAssociatedList
                })
              })]
            });
          }
          Raven.captureMessage('Could not find matching listId for matchingAssociatedListResult', {
            extra: {
              matchingAssociatedListResult,
              associatedLists: flowRevision.flow.associatedLists
            }
          });
          return null;
        }
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.failed.summary"
          }), /*#__PURE__*/_jsx(ListMembershipEventTriggerEvalRenderer, {
            matchResults: validationResult.associatedListsMatchResults,
            flowRevision: flowRevision
          })]
        });
      }
    case 'UNIFIED_EVENT_TRIGGER':
      {
        const {
          unifiedEventTriggerMatchResults,
          // TODO: Account for blocked form submissions
          unifiedEventFetchResult
        } = validationResult;

        // Form submissions from excluded traffic will not trigger an enrollment.
        // https://knowledge.hubspot.com/reports/exclude-traffic-from-your-site-analytics
        if (unifiedEventFetchResult === 'FORM_SUBMISSION_EXCLUDED_FROM_ANALYTICS') {
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.formSubmissionAnalyticsRejected_jsx",
            elements: {
              Link: UILink,
              b: 'b'
            },
            options: {
              onClick: () => usageTracker.track('pageAction', {
                actionType: 'CLICK_LEARN_MORE_FORM_ANALYTICS'
              }),
              external: true,
              href: 'https://knowledge.hubspot.com/reports/exclude-traffic-from-your-site-analytics#:~:text=The%20bot%20activity,Workflow%20enrollments'
            }
          });
        }
        if (unifiedEventFetchResult === 'FORM_SUBMISSION_UNKNOWN') {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.formSubmissionUnknown"
          });
        }
        const isUsingEventEnrollment = flowRevision.flow.enrollmentTrigger === 'EVENT';
        const persistedReEnrollmentLists = flowRevision.flow.associatedLists.filter(list => list.listTypes.includes('PERSISTED_RE_ENROLLMENT_LIST'));
        const eventEnrollmentLists = getListEventTriggers(flowRevision.flow);
        const hasReEnrollmentTriggers = persistedReEnrollmentLists.length > 0 || flowRevision.flow.flowEventFilters.length > 0;
        if (unifiedEventFetchResult === 'ASSOCIATED_TO_DIFFERENT_OBJECT_AT_TIME') {
          if (isUsingEventEnrollment) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.associatedToDifferentObjectAtTime.enrollment"
            });
          }
          if (hasReEnrollmentTriggers) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.associatedToDifferentObjectAtTime.reEnrollment"
            });
          }
        }
        if (unifiedEventFetchResult === 'EVENT_PRODUCED_BEFORE_OBJECT_WAS_CREATED') {
          if (isUsingEventEnrollment) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.eventProducedBeforeObjectCreation.enrollment"
            });
          }
          if (hasReEnrollmentTriggers) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.eventProducedBeforeObjectCreation.reEnrollment"
            });
          }
        }
        if (unifiedEventFetchResult === 'UNSUPPORTED_EMAIL_TYPE') {
          if (isUsingEventEnrollment) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.unsupportedEmailType.enrollment"
            });
          }
          if (hasReEnrollmentTriggers) {
            return /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.unsupportedEmailType.reEnrollment"
            });
          }
        }
        if (unifiedEventFetchResult === 'TIMELINE_ITEM_NOT_APPLICABLE') {
          if (isUsingEventEnrollment) {
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.enrollment"
              }), /*#__PURE__*/_jsx(MarginTopContainer, {
                theme: theme,
                children: /*#__PURE__*/_jsx(WalmartEventEnrollmentFilters, {
                  portalId: flowRevision.portalId,
                  flowObjectTypeId: flowRevision.flow.objectTypeId,
                  flowEventFilters: flowRevision.flow.flowEventFilters,
                  listEventTriggers: eventEnrollmentLists
                })
              })]
            });
          }
          if (hasReEnrollmentTriggers) {
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.reEnrollment.didntMatch"
              }), /*#__PURE__*/_jsx(MarginTopContainer, {
                theme: theme,
                children: /*#__PURE__*/_jsx(WalmartEventEnrollmentFilters, {
                  portalId: flowRevision.portalId,
                  flowObjectTypeId: flowRevision.flow.objectTypeId,
                  flowEventFilters: flowRevision.flow.flowEventFilters,
                  persistedReEnrollmentLists: persistedReEnrollmentLists
                })
              })]
            });
          }
          return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.reEnrollment.noTriggers"
          });
        }
        const matchesWithFlowEventFilters = unifiedEventTriggerMatchResults.map(match => ({
          match,
          flowEventFilter: flowRevision.flow.flowEventFilters.find(f => f.eventFilterId.id === match.eventFilterId)
        }));
        const acceptedFlowEventFilterMatches = matchesWithFlowEventFilters.filter(matchWithFlowEventFilter => matchWithFlowEventFilter.match.isValidTrigger);
        const rejectedFlowEventFilterMatches = matchesWithFlowEventFilters.filter(matchWithFlowEventFilter => !matchWithFlowEventFilter.match.isValidTrigger);
        if (acceptedFlowEventFilterMatches.length > 0) {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: isUsingEventEnrollment ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.passed.enrollment' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.passed.reEnrollment'
            }), /*#__PURE__*/_jsx(MarginTopContainer, {
              theme: theme,
              children: /*#__PURE__*/_jsx(WalmartEventEnrollmentFilters, {
                portalId: flowRevision.portalId,
                flowObjectTypeId: flowRevision.flow.objectTypeId,
                flowEventFilters: acceptedFlowEventFilterMatches.map(m => Object.assign({}, m.flowEventFilter, {
                  debugFilter: m.match.debugFilterBranch
                })),
                listEventTriggers: eventEnrollmentLists,
                persistedReEnrollmentLists: persistedReEnrollmentLists
              })
            })]
          });
        }
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: isUsingEventEnrollment ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.enrollment' : hasReEnrollmentTriggers ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.reEnrollment.didntMatch' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.description.failed.reEnrollment.noTriggers'
          }), (isUsingEventEnrollment || hasReEnrollmentTriggers) && /*#__PURE__*/_jsx(MarginTopContainer, {
            theme: theme,
            children: /*#__PURE__*/_jsx(WalmartEventEnrollmentFilters, {
              portalId: flowRevision.portalId,
              flowObjectTypeId: flowRevision.flow.objectTypeId,
              flowEventFilters: rejectedFlowEventFilterMatches.map(m => Object.assign({}, m.flowEventFilter, {
                debugFilter: m.match.debugFilterBranch
              })),
              listEventTriggers: eventEnrollmentLists,
              persistedReEnrollmentLists: persistedReEnrollmentLists
            })
          })]
        });
      }
    case 'MANUAL_ENROLLMENT':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.MANUAL_ENROLLMENT.description.passed' : ''
      });
    default:
      return null;
  }
};
export default EnrollmentValidTriggerResultExplanation;